import React, { useState } from "react";
import {
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
  Hammer,
  Calendar,
} from "lucide-react";
import logo from "../assets/images/Broadway_logo_whitebackground-03.png"; // Adjust the path as necessary
import logo2 from "../assets/images/Broadway_logo-03.png";
import "./NavbarHeader.css"; // Import your CSS file for styling
import { useLocation } from "react-router-dom";

const NavbarHeader = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  // book your call starts
  const [showCallModal, setShowCallModal] = useState(false);
  const [bookCallFormData, setBookCallFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    callType: "",
    date: "",
    time: "",
    timezone: "EST",
    message: "",
  });
  const [isCallSubmitting, setIsCallSubmitting] = useState(false);
  const [callSubmitted, setCallSubmitted] = useState(false);

  // Generate next 14 days for date selection
  const generateDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 1; i <= 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      // Skip weekends for business calls
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        dates.push({
          value: date.toISOString().split("T")[0],
          label: date.toLocaleDateString("en-US", {
            weekday: "long",
            month: "short",
            day: "numeric",
          }),
        });
      }
    }
    return dates;
  };

  const timeSlots = [
    "09:00 AM",
    "09:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "01:00 PM",
    "01:30 PM",
    "02:00 PM",
    "02:30 PM",
    "03:00 PM",
    "03:30 PM",
    "04:00 PM",
    "04:30 PM",
    "05:00 PM",
  ];

  const timezones = [
    { value: "EST", label: "Eastern (EST)" },
    { value: "CST", label: "Central (CST)" },
    { value: "MST", label: "Mountain (MST)" },
    { value: "PST", label: "Pacific (PST)" },
    { value: "GMT", label: "GMT" },
    { value: "CET", label: "Central European (CET)" },
  ];

  const handleBookCallInputChange = (e) => {
    const { name, value } = e.target;
    setBookCallFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBookCallSubmit = async (e) => {
    e.preventDefault();
    setIsCallSubmitting(true);

    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 2000));

    setIsCallSubmitting(false);
    setCallSubmitted(true);

    // Reset form after 4 seconds and close modal
    setTimeout(() => {
      setBookCallFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        callType: "",
        date: "",
        time: "",
        timezone: "EST",
        message: "",
      });
      setCallSubmitted(false);
      setShowCallModal(false);
    }, 4000);
  };

  const openCallModal = () => setShowCallModal(true);
  const closeCallModal = () => {
    setShowCallModal(false);
    setCallSubmitted(false);
  };

  const availableDates = generateDates();
  // book your call ends

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    service: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1500));

    setIsSubmitting(false);
    setSubmitted(true);

    // Reset form after 3 seconds and close modal
    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        service: "",
        message: "",
      });
      setSubmitted(false);
      setShowModal(false);
    }, 3000);
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setSubmitted(false);
  };
  return (
    <header>
      <nav
        className={`navbar navbar-expand-lg navbar-dark w-100 shadow${
          isHomePage ? " position-absolute" : " position-relative"
        }`}
        style={{ zIndex: 1000 }}
      >
        <div className="container">
          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center" href="/">
            {/* Logo image */}
            <img
              src={logo} // Update this path to your actual logo file location
              alt="Broadway Building Solutions Logo"
              className="me-2"
              style={{
                height: 120,
                width: 120,
                objectFit: "contain",
                borderRadius: "50%",
              }}
            />
            {/* <span className="fw-bold">Broadway Building Solution</span> */}
          </a>

          {/* Mobile toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation items */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <a className="nav-link" href="/">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#about">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/products">
                  Products
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#contact-us">
                  Contact Us
                </a>
              </li>
            </ul>

            {/* CTA Buttons */}
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={openModal}
                className="btn brand-orange text-white px-3 py-2"
              >
                Get a Free Quote
              </button>
              <button onClick={openCallModal} className="btn brand-orange text-white px-3 py-2">
                Book a call
              </button>

              {/* Social Icons */}
              <div className="social-icons d-flex gap-2 ms-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61579532035161"
                  className="d-flex align-items-center justify-content-center rounded text-white text-decoration-none"
                >
                  <Facebook size={25} />
                </a>
                <a
                  href=" https://www.instagram.com/broadway_building"
                  className="d-flex align-items-center justify-content-center rounded text-white text-decoration-none"
                >
                  <Instagram size={25} />
                </a>
                <a
                  href="https://www.linkedin.com/company/broadway-construction-solutions/"
                  className="d-flex align-items-center justify-content-center rounded text-white text-decoration-none"
                >
                  <Linkedin size={25} />
                </a>
                {/* <a
                  href="#"
                  className="d-flex align-items-center justify-content-center rounded text-white text-decoration-none"
                >
                  <Youtube size={25} />
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </nav>
      {showModal && (
        <>
          {/* Modal Backdrop */}
          <div className="modal-backdrop fade show" onClick={closeModal}></div>

          {/* Modal Dialog */}
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="quoteModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header bg-primary-green text-white">
                  <h5 className="modal-title" id="quoteModalLabel">
                    Get Your Free Quote
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={closeModal}
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body p-4">
                  {!submitted ? (
                    <>
                      <p className="text-muted mb-4">
                        Fill out the form below and we'll get back to you within
                        24 hours with a personalized quote.
                      </p>

                      <div onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="name" className="form-label">
                              Full Name *
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="name"
                              name="name"
                              value={formData.name}
                              onChange={handleInputChange}
                              required
                              placeholder="Enter your full name"
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="email" className="form-label">
                              Email Address *
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                              placeholder="Enter your email address"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="phone" className="form-label">
                              Phone Number
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              id="phone"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                              placeholder="Enter your phone number"
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="company" className="form-label">
                              Company Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="company"
                              name="company"
                              value={formData.company}
                              onChange={handleInputChange}
                              placeholder="Your Company"
                            />
                          </div>
                        </div>

                        {/* <div className="mb-3">
                          <label htmlFor="service" className="form-label">
                            Service Interested In *
                          </label>
                          <select
                            className="form-select"
                            id="service"
                            name="service"
                            value={formData.service}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select a service...</option>
                            <option value="web-development">
                              Web Development
                            </option>
                            <option value="mobile-app">
                              Mobile App Development
                            </option>
                            <option value="digital-marketing">
                              Digital Marketing
                            </option>
                            <option value="consulting">Consulting</option>
                            <option value="maintenance">
                              Website Maintenance
                            </option>
                            <option value="other">Other</option>
                          </select>
                        </div> */}

                        <div className="mb-4">
                          <label htmlFor="message" className="form-label">
                            Message
                          </label>
                          <textarea
                            className="form-control"
                            id="message"
                            name="message"
                            rows="4"
                            value={formData.message}
                            onChange={handleInputChange}
                            placeholder="Tell us about your needs, timeline, budget, or any specific questions..."
                          ></textarea>
                        </div>

                        <div className="d-flex justify-content-between">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeModal}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary-green text-white px-4 py-2"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Submitting...
                              </>
                            ) : (
                              "Get My Quote"
                            )}
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-4">
                      <div className="mb-3">
                        <svg
                          width="64"
                          height="64"
                          className="text-success"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg>
                      </div>
                      <h4 className="text-success">Thank You!</h4>
                      <p className="mb-3">
                        Your quote request has been submitted successfully.
                        We'll review your information and get back to you within
                        24 hours.
                      </p>
                      <small className="text-muted">
                        This window will close automatically in a few seconds.
                      </small>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showCallModal && (
        <>
          {/* Modal Backdrop */}
          <div
            className="modal-backdrop fade show"
            onClick={closeCallModal}
          ></div>

          {/* Modal Dialog */}
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="callModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-xl" role="document">
              <div className="modal-content">
                <div className="modal-header bg-primary-green text-white">
                  <h5 className="modal-title" id="callModalLabel">
                    📅 Schedule Your Call
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={closeCallModal}
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body p-4">
                  {!callSubmitted ? (
                    <>
                      <div className="row mb-4">
                        <div className="col-md-8">
                          <p className="text-muted mb-0">
                            Book a complimentary consultation call to discuss
                            your project needs and how we can help you achieve
                            your goals.
                          </p>
                        </div>
                        <div className="col-md-4 text-end">
                          <span className="badge bg-success-subtle text-success fs-6">
                            Free Consultation
                          </span>
                        </div>
                      </div>

                      <div onSubmit={handleBookCallSubmit}>
                        <div className="row">
                          {/* Left Column - Personal Info */}
                          <div className="col-lg-6">
                            <h6 className="text-primary mb-3">
                              Contact Information
                            </h6>

                            <div className="mb-3">
                              <label htmlFor="name" className="form-label">
                                Full Name *
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                value={bookCallFormData.name}
                                onChange={handleBookCallInputChange}
                                required
                                placeholder="Enter your full name"
                              />
                            </div>

                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">
                                Email Address *
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                value={bookCallFormData.email}
                                onChange={handleBookCallInputChange}
                                required
                                placeholder="Enter your email address"
                              />
                            </div>

                            <div className="mb-3">
                              <label htmlFor="phone" className="form-label">
                                Phone Number *
                              </label>
                              <input
                                type="tel"
                                className="form-control"
                                id="phone"
                                name="phone"
                                value={bookCallFormData.phone}
                                onChange={handleBookCallInputChange}
                                required
                                placeholder="Enter your phone number"
                              />
                            </div>

                            <div className="mb-3">
                              <label htmlFor="company" className="form-label">
                                Company Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="company"
                                name="company"
                                value={bookCallFormData.company}
                                onChange={handleBookCallInputChange}
                                placeholder="Your Company"
                              />
                            </div>

                            <div className="mb-3">
                              <label htmlFor="callType" className="form-label">
                                Call Purpose *
                              </label>
                              <select
                                className="form-select"
                                id="callType"
                                name="callType"
                                value={bookCallFormData.callType}
                                onChange={handleBookCallInputChange}
                                required
                              >
                                <option value="">Select call type...</option>
                                <option value="consultation">
                                  Project Consultation
                                </option>
                                <option value="discovery">
                                  Discovery Call
                                </option>
                                <option value="demo">Product Demo</option>
                                <option value="support">
                                  Technical Support
                                </option>
                                <option value="partnership">
                                  Partnership Discussion
                                </option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>

                          {/* Right Column - Scheduling */}
                          <div className="col-lg-6">
                            <h6 className="text-primary mb-3">
                              Schedule Your Call
                            </h6>

                            <div className="mb-3">
                              <label htmlFor="date" className="form-label">
                                Preferred Date *
                              </label>
                              <select
                                className="form-select"
                                id="date"
                                name="date"
                                value={bookCallFormData.date}
                                onChange={handleBookCallInputChange}
                                required
                              >
                                <option value="">Select a date...</option>
                                {availableDates.map((date) => (
                                  <option key={date.value} value={date.value}>
                                    {date.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="mb-3">
                              <label htmlFor="time" className="form-label">
                                Preferred Time *
                              </label>
                              <select
                                className="form-select"
                                id="time"
                                name="time"
                                value={bookCallFormData.time}
                                onChange={handleBookCallInputChange}
                                required
                              >
                                <option value="">Select a time...</option>
                                {timeSlots.map((time) => (
                                  <option key={time} value={time}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="mb-3">
                              <label htmlFor="timezone" className="form-label">
                                Timezone
                              </label>
                              <select
                                className="form-select"
                                id="timezone"
                                name="timezone"
                                value={bookCallFormData.timezone}
                                onChange={handleBookCallInputChange}
                              >
                                {timezones.map((tz) => (
                                  <option key={tz.value} value={tz.value}>
                                    {tz.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="mb-3">
                              <label htmlFor="message" className="form-label">
                                What would you like to discuss?
                              </label>
                              <textarea
                                className="form-control"
                                id="message"
                                name="message"
                                rows="4"
                                value={bookCallFormData.message}
                                onChange={handleBookCallInputChange}
                                placeholder="Brief description of your project or questions you'd like to discuss..."
                              ></textarea>
                            </div>

                            <div className="alert alert-info">
                              <small>
                                <strong>Note:</strong> You'll receive a calendar
                                invitation and Zoom link after booking.
                              </small>
                            </div>
                          </div>
                        </div>

                        <div className="border-top pt-4 mt-4">
                          <div className="d-flex justify-content-between align-items-center">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={closeCallModal}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary-green text-white btn-lg px-4"
                              disabled={isCallSubmitting}
                              onClick={handleBookCallSubmit}
                            >
                              {isCallSubmitting ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Scheduling...
                                </>
                              ) : (
                                <>📅 Book My Call</>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-5">
                      <div className="mb-4">
                        <div
                          className="bg-success-subtle rounded-circle d-inline-flex align-items-center justify-content-center"
                          style={{ width: "80px", height: "80px" }}
                        >
                          <svg
                            width="40"
                            height="40"
                            className="text-success"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                          </svg>
                        </div>
                      </div>
                      <h4 className="text-success mb-3">
                        Your Call is Scheduled! 🎉
                      </h4>
                      <p className="mb-3 text-muted">
                        Thank you for booking a call with us. We've received
                        your request for:
                      </p>
                      <div className="bg-light rounded p-3 mb-4 text-start">
                        <div className="row">
                          <div className="col-sm-6 mb-2">
                            <strong>Date:</strong>{" "}
                            {
                              availableDates.find(
                                (d) => d.value === bookCallFormData.date
                              )?.label
                            }
                          </div>
                          <div className="col-sm-6 mb-2">
                            <strong>Time:</strong> {bookCallFormData.time}{" "}
                            {bookCallFormData.timezone}
                          </div>
                          <div className="col-12">
                            <strong>Purpose:</strong>{" "}
                            {bookCallFormData.callType}
                          </div>
                        </div>
                      </div>
                      <p className="mb-4">
                        You'll receive a calendar invitation and Zoom meeting
                        link within the next 5 minutes. Please check your email
                        and add the event to your calendar.
                      </p>
                      <div className="text-muted">
                        <small>Looking forward to speaking with you!</small>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </header>
  );
};

export default NavbarHeader;
